import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import * as Sentry from '@sentry/react'

import configureStore from 'store/store'

import App from './components/App/App'

import { env, sentry } from './config'
import IssuesTrackers from 'services/issueTracker/issueTrackerService'

export const store = configureStore()

IssuesTrackers.initialize()

const initializeApplication = async () => {
  ReactDOM.render(
    <Provider store={store}>
      <BrowserRouter>
        <App store={store} />
      </BrowserRouter>
    </Provider>,
    document.getElementById('root'),
  )
}

initializeApplication()

export default store
